import { FUNCTIONS } from "src/contexts/FirebaseContext";
import { httpsCallable } from "firebase/functions";

export default async function StripeDashboard() {
  const functionRef = httpsCallable(FUNCTIONS, "ext-firestore-stripe-payments-createPortalLink");
  const { data } = await functionRef({
    returnUrl: window.location.origin,
    // locale: "auto", // Optional, defaults to "auto"
    // configuration: "bpc_1JSEAKHYgolSBA358VNoc2Hs", // Optional ID of a portal configuration: https://stripe.com/docs/api/customer_portal/configuration
  });
  window.location.assign(data.url);
}
